/**
 * Combined feature toggle + permission check.
 *
 * Returns true only if BOTH the deployment-level feature is enabled
 * AND the user has the required permission.
 *
 * Usage:
 *   const canUseVoice = useCanAccessFeature('voice', 'voice:use')
 *   const canUseInbox = useCanAccessFeature('inbox', 'inbox:read')
 */

import { useFeature } from './useFeature'
import { usePermission } from './usePermission'

export function useCanAccessFeature(feature: string, permission: string): boolean {
  const featureEnabled = useFeature(feature)
  const hasPermission = usePermission(permission)
  return featureEnabled && hasPermission
}
